import type { ISbStoriesParams } from '@storyblok/js';
import type { ComputedRef } from 'vue';

export type UseStoryblokApiOptionsReturn = {
    apiOptions: ComputedRef<ISbStoriesParams>;
};

export const useStoryblokApiParams = (extraParams?: ISbStoriesParams): UseStoryblokApiOptionsReturn => {
    const { locale, isDefaultLocale } = useTypedI18n();

    return {
        apiOptions: computed(() => ({
            version: 'published',
            resolve_links: 'url',
            ...(!isDefaultLocale.value ? { language: locale.value } : {}),
            ...extraParams,
        })),
    };
};
